import { Plugin } from 'ckeditor5';

// CommentsIntegration Plugin
export default class CommentsIntegration extends Plugin {
    static get requires() {
        return ['CommentsRepository', 'UsersIntegration'];
    }

    static get pluginName() {
        return 'CommentsIntegration';
    }

    init() {
        const commentsRepositoryPlugin = this.editor.plugins.get('CommentsRepository');

        // Load the comment threads data.
        const commentThreads = sessionStorage.getItem('commentThreads')
            ? JSON.parse(sessionStorage.getItem('commentThreads')!!)
            : [];

        for (const commentThread of commentThreads) {
            commentsRepositoryPlugin.addCommentThread(commentThread);
        }
       
    }
}